var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1454_91053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6562 18.6673C26.6315 17.7933 26.5488 17.236 26.2688 16.7607C25.8702 16.084 25.1528 15.7073 23.7188 14.9553L22.3855 14.2553C21.2148 13.6413 20.6295 13.334 20.0002 13.334C19.3708 13.334 18.7855 13.6407 17.6148 14.2553L16.2815 14.9553C14.8475 15.7073 14.1302 16.084 13.7315 16.7607C13.3335 17.4367 13.3335 18.2787 13.3335 19.962V20.04C13.3335 21.7227 13.3335 22.5647 13.7315 23.2407C14.1302 23.9173 14.8475 24.294 16.2815 25.0467L17.6148 25.746C18.7855 26.36 19.3708 26.6673 20.0002 26.6673C20.6295 26.6673 21.2148 26.3607 22.3855 25.746L23.7188 25.046C25.1528 24.2933 25.8702 23.9173 26.2688 23.2407C26.5488 22.7653 26.6315 22.208 26.6562 21.334M26.0002 17.0007L23.3335 18.334M23.3335 18.334L23.0002 18.5007L20.0002 20.0007M23.3335 18.334V20.6673M23.3335 18.334L17.0002 15.0007M20.0002 20.0007L14.0002 17.0007M20.0002 20.0007V26.334",
    stroke: "#003366",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1454_91053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBroken);
export default __webpack_public_path__ + "static/media/box-broken.a53eb69c9ca8d21a4cdf6b60a622d216.svg";
export { ForwardRef as ReactComponent };